export const SIDE_SHEET_WIDTHS = {
  STANDARD: '296px',
};
